import { v4 as uuid } from 'uuid';

export const generateGooglePlacesSessionToken = (): string => uuid();
